import React, {Component} from "react"
import {Button, Modal} from "react-bootstrap"
import {injectIntl} from 'react-intl'
import IBox from "../../../components/IBox"
import LicenseDetailsTable from "./LicenseDetailsTable"

class LicenseDetailsModal extends Component {
  render() {

    const format = this.props.intl.formatMessage

    const details = this.props.details || []
    return (
      <Modal bsSize="lg"
             show={this.props.show} onHide={this.props.onHide}>

        <Modal.Header closeButton>
          <h2>{format({id: 'license.details'})}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height: 480}}>
          <IBox>

            <LicenseDetailsTable details={details}/>

            <p>{format({id:'desc.total.licenses'}, {limit:this.props.limit})}</p>
          </IBox>

        </Modal.Body>

        <Modal.Footer>

          <div className={`btn btn-primary`}
            onClick={this.props.onHide}>
            {format({id: 'ok'})}
          </div>

        </Modal.Footer>
      </Modal>
    )
  }
}

export default injectIntl(LicenseDetailsModal)



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/LicenseDetailsModal.js